<div class="notification" [ngClass]="toastType">
  <div class="notification__icon" [ngClass]="toastType">
    <span [innerHTML]="icon"></span>
  </div>
  <div class="notification__content">
    <p class="notification__title">{{ title }}</p>
    <p class="notification__message">{{ message }}</p>
  </div>
</div>
